import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { ErrorHandling } from '../../../@types/ErrorHandling'
import {
  SubmitProposalClientRequest,
  SubmitProposalClientResponse,
} from '../../../@types/SubmitProposal'
import { FirstReceiptInfo } from '../../../@types/digitalSignature/RefreshDigitalSignatureStatus'
import { ENV } from '../../../Environment'
import { api } from '../../../Services/API'
import { useFirstReceiptInfo } from '../../../Stores/useFirstReceiptInfo'
import { useSubmitProposalStore } from '../../../Stores/useSubmitProposalStore'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { SESSION_STORAGE } from '../../../constants/sessionStorage'
import { useErrorRequest } from '../../useErrorRequest'

const processNumber = sessionStorage.getItem(SESSION_STORAGE.rpsQuoteId)

const headers = {
  ApplicationCode: ENV().ApplicationCode,
  CoreSystem: ENV().CoreSystem,
  ProductCode: ENV().ProductCode,
  ProcessNumber: processNumber,
}

const request = async (payload: SubmitProposalClientRequest) => {
  const response = await api.post<SubmitProposalClientResponse>(
    API_ROUTES.submitProposal,
    payload,
    { headers },
  )

  return response.data
}

export const useSubmitProposal = () => {
  const { setSubmitProposal, setIsSubmitProposalRequested } =
    useSubmitProposalStore()
  const { setFirstReceiptInfo } = useFirstReceiptInfo()
  const { handleErrorRequest } = useErrorRequest()

  return useMutation({
    mutationFn: (payload: SubmitProposalClientRequest) => request(payload!),
    onSuccess(data) {
      setIsSubmitProposalRequested(true)
      setSubmitProposal(data)
      setFirstReceiptInfo(data.firstReceiptInfo as FirstReceiptInfo)
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({ error })
    },
  })
}
